"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOutsideWalls = void 0;
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTileData_sidecar_1 = require("../../tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("../../tilemap/diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("../../tilemap/diveTilemapPart-sidecar");
var genUtils_1 = require("../common/genUtils");
function addOutsideWalls(info) {
    var rnd, sizeX, sizeY, delay, j, i, gs, hasFloorNeighbor, dirs8_1, dirs8_1_1, d, gs2;
    var e_1, _a;
    return __generator(this, function (_b) {
        rnd = info.rnd, sizeX = info.sizeX, sizeY = info.sizeY, delay = info.delay;
        // Add basic walls around rooms
        for (j = 0; j < sizeY; j++) {
            for (i = 0; i < sizeX; i++) {
                gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
                if (gs.tile1.type === diveTileData_1.EDiveTile.Acid) {
                    hasFloorNeighbor = false;
                    try {
                        for (dirs8_1 = (e_1 = void 0, __values(genUtils_1.dirs8)), dirs8_1_1 = dirs8_1.next(); !dirs8_1_1.done; dirs8_1_1 = dirs8_1.next()) {
                            d = dirs8_1_1.value;
                            gs2 = diveTilemap_sidecar_1.diveTilemap.getSafe(i + d[0], j + d[1]);
                            if (gs2 && gs2.tile1.type === diveTileData_1.EDiveTile.Floor) {
                                hasFloorNeighbor = true;
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (dirs8_1_1 && !dirs8_1_1.done && (_a = dirs8_1.return)) _a.call(dirs8_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    if (hasFloorNeighbor) {
                        // Change to a wall
                        diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Wall));
                    }
                }
            }
        }
        return [2 /*return*/];
    });
}
exports.addOutsideWalls = addOutsideWalls;
